<template lang="pug">
  LayoutDefault
    .page: .container-fluid
      .section
        .heading--section Expiring Structured Warrants
        .pad_t--20
          form.form-inline
            span Show structured warrants that are expiring
            b-form-select.mar_l--10.mar_l--0-xsm.mar_t--10-xsm(v-model="ui_controls.currentTab", size='sm')
              option(value="today") Today
              option(value="week") Within a Week
              option(value="month") Within a Month
              option(value="more") &gt; a Month

      .section
        .card: .card--body
          Loading(:isLoading="isDataLoading", type="bar")
            template(v-if="ui_controls.currentTab === 'today'")
              DataTable(
                :records="today", 
                :headers="headers", 
                :emptyDisplayMessage="`There are no records fo any structured warrants expiring today`",
                :displayItemsPerPage="false",
                :displayPagination="false",
                tableBreak="md",
              )

            template(v-if="ui_controls.currentTab === 'week'")
              DataTable(
                :records="week", 
                :headers="headers", 
                :emptyDisplayMessage="`There are no records fo any structured warrants expiring within a week`",
                :displayItemsPerPage="false",
                :displayPagination="false",
                tableBreak="md",
              )

            template(v-if="ui_controls.currentTab === 'month'")
              DataTable(
                :records="month", 
                :headers="headers", 
                :emptyDisplayMessage="`There are no records fo any structured warrants expiring within a month`",
                :displayItemsPerPage="false",
                :displayPagination="false",
                tableBreak="md",
              )

            template(v-if="ui_controls.currentTab === 'more'")
              DataTable(
                :records="more", 
                :headers="headers", 
                :emptyDisplayMessage="`There are no records fo any structured warrants expiring in more than a month`",
                :displayItemsPerPage="false",
                :displayPagination="false",
                tableBreak="md",
              )

              
</template>



<script>
import requestHandlers from '../../mixins/requestHandlers';
import DataTable from '../../components/DataTable';
import Loading from '../../components/Loading';

export default {
  name: 'expiringWarrants',

  mixins: [requestHandlers],

  components: {
    Loading,
    DataTable
  },

  data() {
    return {
      ui_controls: {
        currentTab: 'today',
      },

      warrants: { },
      headers: [
        {
          id: 'name',
          text: 'Name',
          sortable: true,
          type: 'string',
          colAlignment: 'left',
          colWidth: 25,
        },
        {
          id: 'expiryDate',
          text: 'Expiry Date',
          sortable: true,
          type: 'string',
          colAlignment: 'left',
          colWidth: 15,
        },
        {
          id: 'currentPrice',
          text: 'Current Price',
          sortable: true,
          type: 'number',
          colAlignment: 'center',
          colWidth: 15,
        },
        {
          id: 'change',
          text: 'Change',
          type: 'number',
          colAlignment: 'center',
          colWidth: 12,
        },
        {
          id: 'changePct',
          text: '% Change',
          type: 'number',
          colAlignment: 'center',
          colWidth: 12,
        },
      ]
    }
  },



  computed: {
    warrants_processed() {
      let _timeFrames = {
        inAMonth: [],
        inAWeek: [],
        inMoreThanAMonth: [],
        today: [],
      }

      Object.keys(this.warrants).forEach(key => {
        _timeFrames[key] = this.warrants[key].data.map(w => {
          let _obj = {
            name: w.attributes.name, 
            currentPrice: w.attributes.currentPrice,
            url: w.attributes.announcementUrl,
            change: w.attributes.priceChange,
            changePct: w.attributes.priceChangePct,
            expiryDate: w.attributes.expiryDate,
          };

          return _obj;
        });
      });

      return _timeFrames;
    },


    today() {
      return this.warrants_processed.today;
    },
    week() {
      return this.warrants_processed.inAWeek;
    },
    month() {
      return this.warrants_processed.inAMonth
    },
    more() {
      return this.warrants_processed.inMoreThanAMonth;;
    },
  },



  methods: {
    FETCH_RECORDS() {
      this.REQUEST_INIT();

      this.$axios.get('/UpcomingEvents/ExpiringCounters')
      .then(response => {

        if(response.status !== 200) {
          return;
        }
        this.warrants = response.data;
      })
      .catch(error => this.HANDLE_ERROR_GENERIC(error))
      .then(response => this.REQUEST_FINALLY());
    },

  },


  created() {
    this.FETCH_RECORDS();
  },

}

</script>




<style lang="scss">

</style>
